<template>
  <div class="main-data" v-loading="loading">
    <div class="page-header">
      <div class="page-header__title">
        <span>Okruglar bo'yicha deputatlar</span>
        <el-tag v-if="boardTitle" size="large" type="warning">
          {{ boardTitle }} {{ boardYear }}
        </el-tag>
        <el-tag
          v-if="windowStatus && windowStatus !== 'open'"
          size="large"
          :type="windowStatus === 'not_started' ? 'warning' : 'info'"
        >
          {{ windowStatus === "not_started" ? "Biriktirish oynasi hali boshlanmagan" : "Biriktirish oynasi yopiq" }}
        </el-tag>
      </div>
      <div class="page-header__actions">
        <el-tooltip
          :content="
            windowStatus === 'not_started'
              ? 'Biriktirish oynasi hali boshlanmagan'
              : 'Biriktirish oynasi yopiq'
          "
          placement="top"
          :disabled="canMutate"
        >
          <span>
            <MfExcelImport
              :action="deputiesImportUrl"
              :disabled="!canMutate"
              dialog-title="Deputatlarni Excel orqali biriktirish"
              button-text="Excel import"
              button-type="warning"
              :columns="['F.I.SH', 'PINFL', 'Region_id', 'District_id', 'Okrug_id']"
              hint="PINFL ustunini matn (text) formatida saqlang — aks holda boshidagi nollar yo'qoladi."
              :summary-fields="[{ key: 'assigned', label: 'Biriktirildi' }]"
              template-name="deputatlar-shablon.csv"
              @completed="getOkrugs"
            />
          </span>
        </el-tooltip>
        <el-button type="success" :loading="downloading" @click="downloadExcel">
          <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px" />
          Excel
        </el-button>
        <!-- <el-button type="primary" plain @click="goToChosenInitiatives">
          Loyihalar ijrosi
        </el-button> -->
        <el-button type="info" @click="$router.push({ name: 'ManagerBoards' })">
          Orqaga
        </el-button>
      </div>
    </div>

    <div class="toolbar">
      <div v-if="maxPerBoard && totalDeputies !== null" class="board-summary">
        <el-tag size="large" :type="boardFull ? 'danger' : 'success'" effect="plain">
          Jami deputatlar: {{ totalDeputies }} / {{ maxPerBoard }}
        </el-tag>
      </div>
      <el-input
        v-if="okrugs.length || search"
        v-model="search"
        placeholder="Okrug nomi bo'yicha qidirish"
        clearable
        size="large"
        class="search-control"
        @input="onSearch"
        @clear="onSearch"
      />
    </div>

    <div v-if="okrugs.length" class="okrug-list">
      <div v-for="okrug in okrugs" :key="okrug.okrug_id" class="okrug-card">
        <div class="okrug-card__head">
          <div class="okrug-card__title">
            {{ okrug.okrug_title }}
            <el-tag size="small" :type="isOkrugFull(okrug) ? 'danger' : 'success'" effect="plain">
              {{ okrug.deputies_count }} / {{ okrug.max_deputies }}
            </el-tag>
          </div>
          <div class="okrug-card__actions">
            <el-button
              size="default"
              type="primary"
              plain
              :disabled="!canMutate || isOkrugFull(okrug) || boardFull"
              @click="openAssignDialog(okrug)"
            >
              Mavjud deputatni biriktirish
            </el-button>
            <el-button
              size="default"
              type="primary"
              :disabled="!canMutate || isOkrugFull(okrug) || boardFull"
              @click="openCreateDialog(okrug)"
            >
              Yangi deputat biriktirish
            </el-button>
          </div>
        </div>

        <div v-if="okrug.deputies && okrug.deputies.length" class="deputy-table">
          <el-table :data="okrug.deputies" border size="large">
            <el-table-column type="index" width="50" />
            <el-table-column prop="fullname" label="F.I.O" min-width="200" />
            <el-table-column prop="pinfl" label="PINFL" min-width="150" />
            <el-table-column label="Biriktirgan" min-width="180">
              <template #default="scope">{{ scope.row.assigned_by || "-" }}</template>
            </el-table-column>
            <el-table-column label="Biriktirilgan vaqt" min-width="160">
              <template #default="scope">
                {{ scope.row.assigned_at ? $moment(scope.row.assigned_at).format("DD-MM-YYYY / HH:mm") : "-" }}
              </template>
            </el-table-column>
            <el-table-column width="320" label="Amal" fixed="right">
              <template #default="scope">
                <el-button
                  size="default"
                  type="primary"
                  plain
                  @click="openEditDeputy(scope.row)"
                >
                  Tahrirlash
                </el-button>
                <el-button
                  size="default"
                  type="danger"
                  plain
                  :disabled="!canMutate"
                  @click="unassign(okrug, scope.row)"
                >
                  Biriktirishni bekor qilish
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="deputy-empty">Deputat biriktirilmagan</div>
      </div>
    </div>

    <el-empty v-else-if="!loading" description="Okrug topilmadi" />

    <div v-if="totalCount" class="pagination">
      <div>Okruglar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- Mavjud deputatni biriktirish -->
    <el-dialog
      v-model="assignDialog"
      :title="`Mavjud deputatni biriktirish — ${activeOkrug?.okrug_title || ''}`"
      width="500px"
      @closed="resetAssignDialog"
    >
      <div v-loading="candidatesLoading">
        <el-select
          v-model="selectedDeputyId"
          filterable
          remote
          reserve-keyword
          :remote-method="onCandidatesSearch"
          :loading="candidatesLoading"
          style="width: 100%"
          size="large"
          placeholder="Ism yoki PINFL bo'yicha qidiring"
        >
          <el-option
            v-for="deputy in candidateOptions"
            :key="deputy.deputy_id"
            :value="deputy.deputy_id"
            :label="deputy.fullname + ' (' + deputy.pinfl + ')'"
          />
        </el-select>
        <div v-if="!candidatesLoading && !candidateOptions.length" class="dialog-hint">
          Mos deputat topilmadi. "Yangi deputat" orqali qo'shing.
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="assignDialog = false">Bekor qilish</el-button>
          <el-button
            type="primary"
            :disabled="!selectedDeputyId"
            :loading="assigning"
            @click="assignExisting"
          >
            Biriktirish
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Yangi deputat yaratish + biriktirish -->
    <el-dialog
      v-model="createDialog"
      :title="`Yangi deputat — ${activeOkrug?.okrug_title || ''}`"
      width="580px"
      @closed="resetCreateDialog"
    >
      <el-form ref="createForm" :model="createForm" :rules="createRules" label-position="top">
        <el-form-item label="F.I.O" prop="fullname">
          <!-- Pre-fill banner -->
          <div v-if="selectedDeputy" class="deputy-banner">
            <strong>Mavjud deputat</strong> — ma'lumotlari yuklandi. O'zgartirishlar deputatning
            barcha okruglardagi ma'lumotini yangilaydi.
            <div style="margin-top: 6px; display: flex; gap: 4px; flex-wrap: wrap; align-items: center;">
              <el-tag
                v-for="okrug in selectedDeputy.okrugs"
                :key="okrug.okrug_id"
                size="small"
                type="warning"
              >{{ okrug.okrug_title }}</el-tag>
              <span
                v-if="!selectedDeputy.okrugs || !selectedDeputy.okrugs.length"
                class="deputy-banner__hint"
              >biriktirilmagan</span>
            </div>
          </div>
          <!-- Input + dropdown -->
          <div class="deputy-search-wrapper">
            <el-input
              v-model="createForm.fullname"
              size="large"
              placeholder="Ism Familiya"
              @input="onFullnameInput"
              @focus="onFullnameFocus"
              @blur="onFullnameBlur"
            />
            <div
              v-if="showDeputyDropdown"
              class="deputy-dropdown"
              @mousedown.prevent
            >
              <div
                v-for="item in deputySearchResults"
                :key="item.deputy_id"
                class="deputy-dropdown-item"
                :class="{ 'is-assigned': isAlreadyInOkrug(item) }"
                @click="onDeputySelect(item)"
              >
                <div
                  class="deputy-dropdown-item__name"
                  v-html="highlightMatch(item.fullname, deputySearchQuery)"
                />
                <div class="deputy-dropdown-item__meta">
                  <span class="deputy-dropdown-item__pinfl">{{ item.pinfl }}</span>
                  <span class="deputy-dropdown-item__chips">
                    <el-tag
                      v-for="okrug in item.okrugs"
                      :key="okrug.okrug_id"
                      size="small"
                      type="warning"
                      style="margin-left: 4px"
                    >{{ okrug.okrug_title }}</el-tag>
                    <span
                      v-if="!item.okrugs || !item.okrugs.length"
                      class="deputy-dropdown-item__unassigned"
                    >biriktirilmagan</span>
                  </span>
                </div>
                <div v-if="isAlreadyInOkrug(item)" class="deputy-dropdown-item__warning">
                  Bu okrugga allaqachon biriktirilgan
                </div>
              </div>
              <div v-if="deputySearchLoading" class="deputy-dropdown-status">
                Yuklanmoqda...
              </div>
              <div
                v-if="!deputySearchLoading && deputySearchTotal > deputySearchResults.length"
                class="deputy-dropdown-more"
                @mousedown.prevent="loadMoreDeputySearch"
              >
                Ko'proq yuklash ({{ deputySearchResults.length }} / {{ deputySearchTotal }})
              </div>
              <div
                v-if="!deputySearchLoading && !deputySearchResults.length"
                class="deputy-dropdown-status"
              >
                Topilmadi
              </div>
            </div>
          </div>
          <el-button
            v-if="pinflLocked"
            size="small"
            text
            type="danger"
            style="margin-top: 4px; padding-left: 0"
            @click="clearDeputySelection"
          >
            ✕ Tanlovni tozalash
          </el-button>
        </el-form-item>

        <el-form-item label="PINFL" prop="pinfl">
          <el-input
            v-model="createForm.pinfl"
            size="large"
            maxlength="14"
            inputmode="numeric"
            placeholder="14 ta raqam"
            :disabled="pinflLocked"
            @input="onPinflInput"
          />
        </el-form-item>

        <el-form-item label="Viloyat" prop="region_id">
          <el-select
            v-model="createForm.region_id"
            style="width: 100%"
            size="large"
            placeholder="Viloyatni tanlang"
            :loading="regionsLoading"
            @change="onChangeRegion"
          >
            <el-option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
              :label="region.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tuman/Shahar">
          <el-select
            v-model="createForm.district_id"
            style="width: 100%"
            size="large"
            clearable
            placeholder="Tumanni tanlang"
            :loading="districtsLoading"
          >
            <el-option
              v-for="district in districts"
              :key="district.id"
              :value="district.id"
              :label="district.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Fraksiya">
          <el-select
            v-model="createForm.fraction_id"
            style="width: 100%"
            size="large"
            clearable
            placeholder="Fraksiyani tanlang"
          >
            <el-option
              v-for="fraction in fractions"
              :key="fraction.id"
              :value="fraction.id"
              :label="fraction.title"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="createDialog = false">Bekor qilish</el-button>
          <el-button type="primary" :loading="creating" @click="createDeputy">
            Yaratish va biriktirish
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Deputatni tahrirlash -->
    <el-dialog
      v-model="editDialog"
      title="Deputatni tahrirlash"
      width="500px"
      @closed="resetEditDialog"
    >
      <el-form
        v-loading="editLoading"
        ref="editFormRef"
        :model="editForm"
        :rules="editRules"
        label-position="top"
      >
        <el-form-item label="F.I.O" prop="fullname">
          <el-input v-model="editForm.fullname" size="large" placeholder="Ism Familiya" />
        </el-form-item>

        <el-form-item label="PINFL">
          <el-input v-model="editForm.pinfl" size="large" disabled />
        </el-form-item>

        <el-form-item label="Viloyat" prop="region_id">
          <el-select
            v-model="editForm.region_id"
            style="width: 100%"
            size="large"
            placeholder="Viloyatni tanlang"
            :loading="regionsLoading"
            @change="onEditChangeRegion"
          >
            <el-option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
              :label="region.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tuman/Shahar">
          <el-select
            v-model="editForm.district_id"
            style="width: 100%"
            size="large"
            clearable
            placeholder="Tumanni tanlang"
            :loading="editDistrictsLoading"
          >
            <el-option
              v-for="district in editDistricts"
              :key="district.id"
              :value="district.id"
              :label="district.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Fraksiya">
          <el-select
            v-model="editForm.fraction_id"
            style="width: 100%"
            size="large"
            clearable
            placeholder="Fraksiyani tanlang"
          >
            <el-option
              v-for="fraction in fractions"
              :key="fraction.id"
              :value="fraction.id"
              :label="fraction.title"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialog = false">Bekor qilish</el-button>
          <el-button type="primary" :loading="editSaving" @click="saveEditDeputy">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessageBox, ElNotification } from "element-plus";
import MfExcelImport from "@/components/core/MfExcelImport.vue";
import { blobErrorMessage } from "@/utils/common";

export default {
  name: "ManagerBoardOkrugs",
  components: { MfExcelImport },
  data() {
    const validatePinfl = (rule, value, callback) => {
      if (!value) { callback(new Error("Majburiy maydon")); return; }
      if (!/^\d{14}$/.test(value)) {
        callback(new Error("PINFL 14 ta raqamdan iborat bo'lishi kerak"));
        return;
      }
      callback();
    };

    return {
      loading: false,
      downloading: false,
      boardTitle: this.$route.query.title || "",
      boardYear: this.$route.query.year || "",
      windowOpen: null,
      windowStatus: null,
      maxPerBoard: 0,
      totalDeputies: null,
      okrugs: [],
      search: "",
      searchTimer: null,
      totalCount: 0,
      limit: 10,
      currentPage: 1,
      activeOkrug: null,
      // assign existing
      assignDialog: false,
      candidatesLoading: false,
      candidates: [],
      candidatesLimit: 20,
      candidatesTimer: null,
      selectedDeputyId: null,
      assigning: false,
      // create new
      createDialog: false,
      creating: false,
      regions: [],
      districts: [],
      regionsLoading: false,
      districtsLoading: false,
      pendingDistrictId: null,
      fractions: [],
      createForm: {
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        fraction_id: null,
      },
      createRules: {
        fullname: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        pinfl: [{ validator: validatePinfl, trigger: "blur" }],
        region_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
      },
      // edit deputy (global info)
      editDialog: false,
      editLoading: false,
      editSaving: false,
      editDeputyId: null,
      editForm: {
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        fraction_id: null,
      },
      editRules: {
        fullname: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        region_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
      },
      editDistricts: [],
      editDistrictsLoading: false,
      editPendingDistrictId: null,
      // deputy name typeahead / PINFL prefill
      deputySearchQuery: "",
      deputySearchResults: [],
      deputySearchTotal: 0,
      deputySearchLoading: false,
      deputySearchTimer: null,
      deputySearchOffset: 0,
      DEPUTY_SEARCH_LIMIT: 10,
      showDeputyDropdown: false,
      selectedDeputy: null,
      pinflLocked: false,
      pinflPrefillActive: false,
      pinflSearchTimer: null,
    };
  },
  computed: {
    boardId() {
      return Number(this.$route.params.boardId);
    },
    canMutate() {
      return this.windowOpen === true;
    },
    deputiesImportUrl() {
      return `${process.env.VUE_APP_BASE_API_URL}api/v1/deputyv2/deputy-manager/deputies-sync-excel?board_id=${this.boardId}`;
    },
    boardFull() {
      return this.maxPerBoard > 0 && this.totalDeputies >= this.maxPerBoard;
    },
    candidateOptions() {
      const assignedIds = new Set(
        (this.activeOkrug?.deputies || []).map((item) => item.deputy_id)
      );
      return this.candidates.filter((item) => !assignedIds.has(item.deputy_id));
    },
  },
  methods: {
    isOkrugFull(okrug) {
      return (okrug.deputies_count || 0) >= (okrug.max_deputies || 0);
    },
    handleError(response, fallback) {
      const code = response?.data?.specific_slug;
      const messages = {
        DEPUTY_WINDOW_NOT_STARTED: "Biriktirish oynasi hali boshlanmagan",
        DEPUTY_WINDOW_CLOSED: "Biriktirish oynasi yopilgan",
        ALREADY_ASSIGNED: "Deputat allaqachon shu okrugga biriktirilgan",
        OKRUG_DEPUTY_LIMIT: "Okrug uchun maksimal deputatlar soniga yetildi",
        BOARD_DEPUTY_LIMIT: "Kengash uchun maksimal deputatlar soniga yetildi",
        DEPUTY_OKRUG_LIMIT:
          "Deputat ushbu mavsumda maksimal okruglar soniga (2 ta) biriktirilgan",
        BOARD_TYPE_NOT_SUPPORTED:
          "Deputat moduli faqat Tashabbus va Mening bog'im kengashlarida ishlaydi",
      };
      ElNotification({
        type: "error",
        title: "Xatolik",
        message: messages[code] || response?.data?.message || fallback,
      });
      const refreshCodes = [
        "DEPUTY_WINDOW_CLOSED",
        "DEPUTY_WINDOW_NOT_STARTED",
        "OKRUG_DEPUTY_LIMIT",
        "BOARD_DEPUTY_LIMIT",
        "DEPUTY_OKRUG_LIMIT",
      ];
      if (refreshCodes.includes(code)) {
        this.getOkrugs();
      }
    },
    getOkrugs() {
      this.loading = true;
      this.$http
        .get(`api/v1/deputyv2/deputy-manager/boards/${this.boardId}/okrugs`, {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.okrugs = data.okrugs || [];
          this.windowOpen = data.window_open;
          this.windowStatus = data.window_status || null;
          this.maxPerBoard = data.max_deputies_per_board || 0;
          this.totalDeputies =
            typeof data.total_deputies === "number" ? data.total_deputies : null;
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getOkrugs();
      }, 400);
    },
    goToChosenInitiatives() {
      this.$router.push({
        name: "BoardChosenInitiatives",
        params: { boardId: this.boardId },
        query: { title: this.boardTitle, year: this.boardYear },
      });
    },
    handleCurrentChange() {
      this.getOkrugs();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getOkrugs();
    },
    // --- Assign existing deputy ---
    openAssignDialog(okrug) {
      this.activeOkrug = okrug;
      this.selectedDeputyId = null;
      this.assignDialog = true;
      this.getCandidates(okrug.okrug_id);
    },
    resetAssignDialog() {
      clearTimeout(this.candidatesTimer);
      this.selectedDeputyId = null;
      this.candidates = [];
      this.activeOkrug = null;
    },
    onCandidatesSearch(query) {
      if (!this.activeOkrug) return;
      clearTimeout(this.candidatesTimer);
      this.candidatesTimer = setTimeout(() => {
        this.getCandidates(this.activeOkrug.okrug_id, query);
      }, 400);
    },
    getCandidates(okrugId, search) {
      this.candidatesLoading = true;
      this.$http
        .get(`api/v1/deputyv2/deputy-manager/okrugs/${okrugId}/candidate-deputies`, {
          params: { search: search || null, limit: this.candidatesLimit, offset: 0 },
        })
        .then(({ data }) => {
          this.candidates = data.deputies || [];
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Nomzodlarni yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.candidatesLoading = false;
        });
    },
    assignExisting() {
      if (!this.selectedDeputyId || !this.activeOkrug) return;
      this.assigning = true;
      this.$http
        .post("api/v1/deputyv2/deputy-manager/assignments", {
          deputy_id: this.selectedDeputyId,
          okrug_id: this.activeOkrug.okrug_id,
          board_id: this.boardId,
        })
        .then(() => {
          ElNotification({ type: "success", title: "Bajarildi", message: "Deputat biriktirildi" });
          this.assignDialog = false;
          this.getOkrugs();
        })
        .catch(({ response }) => {
          this.handleError(response, "Biriktirishda xatolik sodir bo'ldi");
        })
        .finally(() => {
          this.assigning = false;
        });
    },
    // --- Create new deputy + assign ---
    openCreateDialog(okrug) {
      this.activeOkrug = okrug;
      this.createDialog = true;
      if (!this.regions.length) this.getRegions();
    },
    resetCreateDialog() {
      this.createForm = {
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        fraction_id: null,
      };
      this.districts = [];
      this.activeOkrug = null;
      this.selectedDeputy = null;
      this.pinflLocked = false;
      this.pinflPrefillActive = false;
      this.pendingDistrictId = null;
      this.deputySearchQuery = "";
      this.deputySearchResults = [];
      this.deputySearchTotal = 0;
      this.deputySearchOffset = 0;
      this.showDeputyDropdown = false;
      clearTimeout(this.deputySearchTimer);
      clearTimeout(this.pinflSearchTimer);
      this.$refs.createForm?.clearValidate();
    },
    onPinflInput(value) {
      this.createForm.pinfl = String(value || "").replace(/\D/g, "").slice(0, 14);
      if (this.pinflPrefillActive || this.pinflLocked) return;
      const pinfl = this.createForm.pinfl;
      clearTimeout(this.pinflSearchTimer);
      if (pinfl.length === 14) {
        this.pinflSearchTimer = setTimeout(() => this.searchDeputiesByPinfl(pinfl), 0);
      }
    },
    searchDeputiesByPinfl(pinfl) {
      this.$http
        .get("api/v1/deputyv2/deputy-manager/deputies-search", {
          params: { board_id: this.boardId, q: pinfl, limit: 1, offset: 0 },
        })
        .then(({ data }) => {
          const results = data.deputies || [];
          if (results.length === 1) this.onDeputySelect(results[0]);
        })
        .catch(() => {});
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => { this.regions = data.regions || []; })
        .catch(() => {})
        .finally(() => { this.regionsLoading = false; });
    },
    onChangeRegion() {
      this.createForm.district_id = null;
      this.districts = [];
      if (!this.createForm.region_id) return;
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", { params: { region_id: this.createForm.region_id } })
        .then(({ data }) => {
          this.districts = data.districts || [];
          if (this.pendingDistrictId) {
            this.createForm.district_id = this.pendingDistrictId;
            this.pendingDistrictId = null;
          }
        })
        .catch(() => {})
        .finally(() => { this.districtsLoading = false; });
    },
    createDeputy() {
      this.$refs.createForm.validate((valid) => {
        if (!valid || !this.activeOkrug) return;
        this.creating = true;
        const payload = {
          fullname: this.createForm.fullname.trim(),
          pinfl: String(this.createForm.pinfl),
          region_id: this.createForm.region_id,
          okrug_id: this.activeOkrug.okrug_id,
          board_id: this.boardId,
        };
        if (this.createForm.district_id) payload.district_id = this.createForm.district_id;
        if (this.createForm.fraction_id) payload.fraction_id = this.createForm.fraction_id;
        this.$http
          .post("api/v1/deputyv2/deputy-manager/deputies", payload)
          .then(() => {
            ElNotification({ type: "success", title: "Bajarildi", message: "Deputat yaratildi va biriktirildi" });
            this.createDialog = false;
            this.getOkrugs();
          })
          .catch(({ response }) => {
            this.handleError(response, "Deputat yaratishda xatolik sodir bo'ldi");
          })
          .finally(() => { this.creating = false; });
      });
    },
    // --- Fractions (used by both create and edit dialogs) ---
    getFractions() {
      this.$http
        .get("api/v1/deputyv2/fractions", { params: { limit: 200, offset: 0 } })
        .then(({ data }) => {
          this.fractions = data.fractions || [];
        })
        .catch(() => {});
    },
    // --- Edit deputy (global info) ---
    openEditDeputy(deputy) {
      this.editDeputyId = deputy.deputy_id;
      this.editDialog = true;
      this.editLoading = true;
      if (!this.regions.length) this.getRegions();
      this.$http
        .get(`api/v1/deputyv2/deputy-manager/deputies/${deputy.deputy_id}`)
        .then(({ data }) => {
          this.editForm = {
            fullname: data.fullname || "",
            pinfl: data.pinfl || "",
            region_id: data.region_id || null,
            district_id: null,
            fraction_id: data.fraction_id || null,
          };
          this.editPendingDistrictId = data.district_id || null;
          if (this.editForm.region_id) {
            this.onEditChangeRegion();
          }
        })
        .catch(({ response }) => {
          this.editDialog = false;
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Deputat ma'lumotlarini yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    onEditChangeRegion() {
      this.editForm.district_id = null;
      this.editDistricts = [];
      if (!this.editForm.region_id) return;
      this.editDistrictsLoading = true;
      this.$http
        .get("/api/v1/districts", { params: { region_id: this.editForm.region_id } })
        .then(({ data }) => {
          this.editDistricts = data.districts || [];
          if (this.editPendingDistrictId) {
            this.editForm.district_id = this.editPendingDistrictId;
            this.editPendingDistrictId = null;
          }
        })
        .catch(() => {})
        .finally(() => { this.editDistrictsLoading = false; });
    },
    saveEditDeputy() {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid || !this.editDeputyId) return;
        this.editSaving = true;
        const payload = { fullname: this.editForm.fullname.trim(), region_id: this.editForm.region_id };
        if (this.editForm.district_id) payload.district_id = this.editForm.district_id;
        if (this.editForm.fraction_id) payload.fraction_id = this.editForm.fraction_id;
        this.$http
          .put(`api/v1/deputyv2/deputy-manager/deputies/${this.editDeputyId}`, payload)
          .then(() => {
            ElNotification({ type: "success", title: "Bajarildi", message: "Deputat ma'lumotlari yangilandi" });
            this.editDialog = false;
            this.getOkrugs();
          })
          .catch(({ response }) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response?.data?.message || "Saqlashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => { this.editSaving = false; });
      });
    },
    resetEditDialog() {
      this.editDeputyId = null;
      this.editForm = { fullname: "", pinfl: "", region_id: null, district_id: null, fraction_id: null };
      this.editDistricts = [];
      this.editPendingDistrictId = null;
      this.$refs.editFormRef?.clearValidate();
    },
    // --- Deputy name typeahead ---
    onFullnameInput(value) {
      const q = (value || "").trim();
      this.deputySearchQuery = q;
      this.deputySearchOffset = 0;
      clearTimeout(this.deputySearchTimer);
      if (q.length < 3) {
        this.showDeputyDropdown = false;
        this.deputySearchResults = [];
        this.deputySearchTotal = 0;
        return;
      }
      this.deputySearchTimer = setTimeout(() => this.searchDeputies(q, false), 300);
    },
    onFullnameFocus() {
      if (
        this.deputySearchQuery.length >= 3 &&
        (this.deputySearchResults.length > 0 || this.deputySearchLoading)
      ) {
        this.showDeputyDropdown = true;
      }
    },
    onFullnameBlur() {
      setTimeout(() => { this.showDeputyDropdown = false; }, 200);
    },
    searchDeputies(q, append) {
      const offset = append ? this.deputySearchOffset : 0;
      if (!append) this.deputySearchResults = [];
      this.deputySearchLoading = true;
      this.showDeputyDropdown = true;
      this.$http
        .get("api/v1/deputyv2/deputy-manager/deputies-search", {
          params: { board_id: this.boardId, q, limit: this.DEPUTY_SEARCH_LIMIT, offset },
        })
        .then(({ data }) => {
          const results = data.deputies || [];
          this.deputySearchTotal = data.count || 0;
          this.deputySearchResults = append
            ? [...this.deputySearchResults, ...results]
            : results;
          this.deputySearchOffset = this.deputySearchResults.length;
        })
        .catch(() => { this.showDeputyDropdown = false; })
        .finally(() => { this.deputySearchLoading = false; });
    },
    loadMoreDeputySearch() {
      if (!this.deputySearchQuery || this.deputySearchLoading) return;
      this.searchDeputies(this.deputySearchQuery, true);
    },
    onDeputySelect(item) {
      if (!item) return;
      if (this.isAlreadyInOkrug(item)) {
        ElNotification({
          type: "warning",
          title: "Diqqat",
          message: "Bu deputat ushbu okrugga allaqachon biriktirilgan",
        });
        return;
      }
      this.selectedDeputy = item;
      this.pinflLocked = true;
      this.showDeputyDropdown = false;
      this.pinflPrefillActive = true;
      this.createForm.fullname = item.fullname;
      this.createForm.pinfl = item.pinfl;
      this.createForm.region_id = item.region_id || null;
      this.createForm.district_id = null;
      this.pendingDistrictId = item.district_id || null;
      if (item.region_id) {
        this.districts = [];
        this.onChangeRegion();
      }
      this.$nextTick(() => { this.pinflPrefillActive = false; });
    },
    clearDeputySelection() {
      this.selectedDeputy = null;
      this.pinflLocked = false;
      this.createForm.fullname = "";
      this.createForm.pinfl = "";
      this.createForm.region_id = null;
      this.createForm.district_id = null;
      this.districts = [];
      this.pendingDistrictId = null;
      this.deputySearchQuery = "";
      this.deputySearchResults = [];
      this.deputySearchTotal = 0;
      this.showDeputyDropdown = false;
    },
    isAlreadyInOkrug(item) {
      if (!item || !item.okrugs || !this.activeOkrug) return false;
      return item.okrugs.some((o) => o.okrug_id === this.activeOkrug.okrug_id);
    },
    highlightMatch(text, query) {
      if (!query || !text) return text;
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return text.replace(new RegExp(`(${escaped})`, "gi"), "<mark>$1</mark>");
    },
    // --- Unassign ---
    unassign(okrug, deputy) {
      ElMessageBox.confirm(
        `"${deputy.fullname}" deputatining "${okrug.okrug_title}" okrugidagi biriktirilishini bekor qilasizmi?`,
        "Diqqat!",
        { confirmButtonText: "Ha", cancelButtonText: "Bekor qilish", type: "warning" }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete("api/v1/deputyv2/deputy-manager/assignments", {
              data: { deputy_id: deputy.deputy_id, okrug_id: okrug.okrug_id, board_id: this.boardId },
            })
            .then(() => {
              ElNotification({ type: "success", title: "Bajarildi", message: "Biriktirish bekor qilindi" });
              this.getOkrugs();
            })
            .catch(({ response }) => {
              this.loading = false;
              this.handleError(response, "Uzishda xatolik sodir bo'ldi");
            });
        })
        .catch(() => {});
    },
    // --- Excel ---
    getFileName(headers, fallback) {
      const contentDisposition = headers?.["content-disposition"] || headers?.["Content-Disposition"];
      if (!contentDisposition) return fallback;
      const part = contentDisposition.split(";").find((item) => item.trim().startsWith("filename="));
      if (!part) return fallback;
      return decodeURIComponent(part.split("=")[1].trim().replace(/^"(.*)"$/, "$1"));
    },
    downloadExcel() {
      this.downloading = true;
      this.$http
        .get("api/v1/deputyv2/deputy-manager/board-deputies/excel", {
          params: { board_id: this.boardId },
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.getFileName(res.headers, "board-deputies.xlsx"));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(async ({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message: await blobErrorMessage(response, "Excel yuklashda xatolik sodir bo'ldi!"),
            type: "warning",
          });
        })
        .finally(() => { this.downloading = false; });
    },
  },
  mounted() {
    this.getOkrugs();
    this.getFractions();
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.page-header__title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 22px;
  font-weight: 600;
  flex-wrap: wrap;
}
.page-header__actions {
  display: flex;
  gap: 10px;
}
.toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.board-summary {
  flex-shrink: 0;
}
.board-summary :deep(.el-tag) {
  height: 46px;
  padding: 0 18px;
  font-size: 16px;
  line-height: 46px;
}
.search-control {
  width: 360px;
  max-width: 100%;
  font-size: 16px;
}
.search-control :deep(.el-input__wrapper) {
  min-height: 46px;
}
.okrug-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.okrug-card {
  border: 1px solid #dcdfe6;
  border-radius: 12px;
  padding: 16px 18px;
  background: #fff;
}
.okrug-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.okrug-card__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  flex-wrap: wrap;
}
.okrug-card__actions {
  display: flex;
  gap: 8px;
}
.deputy-empty {
  color: #909399;
  font-size: 15px;
  padding: 6px 2px;
}
.deputy-table :deep(.el-table) {
  font-size: 15px;
}
.deputy-table :deep(.el-table th .cell) {
  font-size: 15px;
}
.dialog-hint {
  margin-top: 12px;
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

/* Deputy name typeahead */
.deputy-search-wrapper {
  position: relative;
  width: 100%;
}
.deputy-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 320px;
  overflow-y: auto;
  z-index: 2000;
}
.deputy-dropdown-item {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s;
}
.deputy-dropdown-item:last-child {
  border-bottom: none;
}
.deputy-dropdown-item:hover {
  background: #f5f7fa;
}
.deputy-dropdown-item.is-assigned {
  background: #fff8f0;
  cursor: default;
}
.deputy-dropdown-item.is-assigned:hover {
  background: #fff0e0;
}
.deputy-dropdown-item__name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
}
.deputy-dropdown-item__name :deep(mark) {
  background: #ffd04b;
  color: inherit;
  padding: 0 1px;
  border-radius: 2px;
}
.deputy-dropdown-item__meta {
  margin-top: 3px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.deputy-dropdown-item__pinfl {
  font-size: 12px;
  color: #909399;
  font-family: monospace;
}
.deputy-dropdown-item__unassigned {
  font-size: 12px;
  color: #c0c4cc;
  margin-left: 4px;
}
.deputy-dropdown-item__warning {
  margin-top: 3px;
  font-size: 12px;
  color: #e6a23c;
}
.deputy-dropdown-status {
  padding: 12px 14px;
  font-size: 13px;
  color: #909399;
  text-align: center;
}
.deputy-dropdown-more {
  padding: 10px 14px;
  font-size: 13px;
  color: #409eff;
  cursor: pointer;
  text-align: center;
  border-top: 1px solid #f0f0f0;
}
.deputy-dropdown-more:hover {
  background: #ecf5ff;
}

/* Pre-fill banner */
.deputy-banner {
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  margin-bottom: 8px;
}
.deputy-banner__hint {
  font-size: 12px;
  color: #909399;
}
</style>
